<template>
  <v-tour name="HeaderTour" :steps="steps" :options="options">
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :highlight="true"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          data-cy="tourModalStep"
        >
          <template>
            <div slot="header" class="header-display">
              <h4 class="modal-title" v-if="tour.currentStep === 0">
                <span>
                  <md-icon class="title-icon">menu</md-icon>
                </span>
                Main menu
              </h4>
              <h4 class="modal-title" v-if="tour.currentStep === 1">
                <span>
                  <md-icon class="title-icon">notifications</md-icon>
                </span>
                Notifications
              </h4>
              <h4 class="modal-title" v-if="tour.currentStep === 2">
                <span>
                  <md-icon class="title-icon">account_circle</md-icon>
                </span>
                Profile menu
              </h4>
              <md-button class="md-icon-button" @click="closeTour()">
                <md-icon class="close-modal">close</md-icon>
              </md-button>
            </div>
            <div slot="content">
              <p v-if="tour.currentStep === 0" class="modal-text">
                <span class="font-strong">Hovering</span> the cursor here you
                can see all your <span class="font-strong">activities</span>,
                <span class="font-strong">chats</span>, see and create
                <span class="font-strong">groups</span> and
                <span class="font-strong">post items</span>. Also support and
                terms.
              </p>
              <p v-if="tour.currentStep === 1" class="modal-text">
                <span class="font-strong">Hovering</span> the cursor here you
                can check <span class="font-strong">new messages</span> and
                <span class="font-strong">new requests</span> or
                <span class="font-strong">offers</span>.
              </p>
              <p v-if="tour.currentStep === 2" class="modal-text">
                <span class="font-strong">Hovering</span> the cursor here you
                can manage <span class="font-strong">your profile</span>,
                <span class="font-strong">invite friends</span> to join Swampum
                and check your
                <span class="font-strong">points history</span> (spent and
                earned).
              </p>
            </div>
            <div slot="actions">
              <div class="row">
                <div class="col col-3 nav-circles">
                  <span
                    class="circle"
                    :class="[{ 'highlighted-circle': tour.currentStep === 0 }]"
                  ></span>
                  <span
                    class="circle"
                    :class="[{ 'highlighted-circle': tour.currentStep === 1 }]"
                  ></span>
                  <span
                    class="circle"
                    :class="[{ 'highlighted-circle': tour.currentStep === 2 }]"
                  ></span>
                </div>
                <div class="modal-buttons col col-8">
                  <SButtonMaterial
                    buttonType="button"
                    color="white"
                    textColor="primary"
                    materialClass="dense"
                    text="Back"
                    @button="tour.previousStep"
                    data-cy="tourModalStepBack-btn"
                    v-if="tour.currentStep !== 0"
                  />
                  <SButtonMaterial
                    buttonType="button"
                    color="primary"
                    textColor="white"
                    materialClass="dense"
                    text="Next"
                    @button="tour.nextStep"
                    data-cy="tourModalStepNext-btn"
                    v-if="tour.currentStep !== 2"
                  />
                  <SButtonMaterial
                    buttonType="button"
                    color="primary"
                    textColor="white"
                    materialClass="dense"
                    text="Got it"
                    @button="closeTour"
                    data-cy="tourModalFinish-btn"
                    v-if="tour.currentStep === 2"
                  />
                  <md-checkbox
                    v-if="tour.currentStep === 2"
                    v-model="dontShowTourAgainCheck"
                    data-cy="dontShowTourAgain-check"
                    class="md-primary"
                  >
                    <span class="modal-text small">Don't show this again</span>
                  </md-checkbox>
                </div>
              </div>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
import UserHelperVue from "@/mixins/UserHelper.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import modalType from "@/enum/modal-type";

export default {
  name: "HeaderTour",
  mixins: [UserHelperVue],
  props: ["dontShow"],
  components: {
    SButtonMaterial,
  },
  data() {
    return {
      steps: [
        {
          target: '[data-v-step="0"]',
        },
        {
          target: '[data-v-step="1"]',
        },
        {
          target: '[data-v-step="2"]',
          params: {
            placement: "top",
          },
        },
      ],
      options: {
        highlight: true,
      },
      dontShowTourAgainCheck: false,
    };
  },
  methods: {
    async closeTour() {
      if (this.dontShowTourAgainCheck === true) {
        await this.saveOptionDontShowAgain();
      }
      this.$tours["HeaderTour"].finish();
      this.$emit("onFinishTour", true);
    },
    async saveOptionDontShowAgain() {
      const userTourModal = {
        modal_Type: modalType.HEADER_TOUR,
        user_Id: this.loggedUser.id,
      };
      await this.saveDontShowAgain(userTourModal);
    },
    onEscapeKeyUp(event){
      if (event.which === 27) {
        this.closeTour();
      }
    }
  },
  mounted(){
    window.addEventListener("keyup", this.onEscapeKeyUp);
  },
};
</script>

<style lang="scss" scoped>
.v-step {
  background-color: $white !important;
  max-width: unset;
  width: 500px;
  border-radius: 7px;
  border: 1px $primary solid;
}
.header-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.close-button {
  color: black;
  margin-right: 5%;
  cursor: pointer;
  font-size: 14px;
}
@media screen and (max-width: 1024px) {
  .v-step {
    width: 300px;
  }
}
.font-strong {
  font-weight: 700;
}
.modal-text {
  font-weight: 400;
  font-size: 16px;
  color: $black;
  opacity: 0.7;
}
.modal-title {
  font-weight: 700;
  font-size: 20px;
  color: $primary;
}
.modal-title,
.modal-text {
  margin: 20px;
  line-height: 20px;
  text-align: left;
  letter-spacing: 1.25px;
  font-style: normal;
}
.title-icon {
  color: $primary !important;
  margin-bottom: 3px;
  margin-right: 5px;
  font-size: 30px !important;
}
.modal-buttons {
  margin-right: 1rem;
  text-align: end;
}
.circle {
  height: 8px;
  width: 8px;
  background-color: $white;
  border: 1px $primary solid;
  border-radius: 50%;
  margin-right: 2px;
  display: inline-block;
}
.highlighted-circle {
  background-color: $primary;
}
.nav-circles {
  margin-right: 1rem;
  padding-top: 1rem;
}
.small {
  font-size: 12px;
  margin: unset;
}
</style>

<style lang="scss">
.md-checkbox.md-theme-swampum-primary.md-checked .md-checkbox-container {
  background-color: $primary !important;
  border-color: $primary !important;
}
.md-checkbox .md-checkbox-container {
  border-color: $primary !important;
  border-radius: 5px;
}
.md-checkbox .md-checkbox-label {
  padding-left: 10px;
  margin-right: unset;
}
.md-checkbox {
  margin: auto;
}
.v-step__arrow,
.v-step__arrow:before {
  border-top: 1px $primary solid;
  border-left: 1px $primary solid;
  top: -2px;
}
.v-tour__target--highlighted {
  box-shadow: 0 0 0 3px $primary;
  pointer-events: unset;
}
</style>
